export default __webpack_public_path__ + "static/media/withdraw-reward-step6.5ca4bd73.png";